import React from "react";
import * as c from "./footerWave.module.scss";

const FooterWave = () => {
  return (
    <div className={c.wave}>
      <svg xmlns="http://www.w3.org/2000/svg" width="360" height="67" viewBox="0 0 360 67" fill="none">
        <path
          d="M369 35.2589C292.928 6.16592 286.292 75.2086 225.046 31.9653C163.8 -11.2779 136.502 43.1105 96.5012 53.5552C56.5 64 17 44.5 -9 6"
          stroke="url(#paint0_linear_9145_3051)"
          strokeWidth="20"
        />
        <defs>
          <linearGradient
            id="paint0_linear_9145_3051"
            x1="-8.99999"
            y1="13.7032"
            x2="369"
            y2="13.7032"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#C098F5" />
            <stop offset="0.5" stopColor="#FAA4CD" />
            <stop offset="1" stopColor="#FFC9A3" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default FooterWave;
